/* @flow */
import * as React from 'react';

import Link from 'components/Link';

type Props = {
  label: React.Element<any>,
  url: string,
  method: 'to' | 'href',
};

function LinkCell({ label, url, method }: Props) {
  if (!url || !label) {
    return null;
  }

  const stopProp = (e: SyntheticMouseEvent<>) => e.stopPropagation();

  if (method === 'href') {
    return (
      <Link href={url} onClick={stopProp}>
        {label}
      </Link>
    );
  }

  return (
    <Link to={url} onClick={stopProp}>
      {label}
    </Link>
  );
}

export function getLinkCellGenerator(
  urlFieldName: string,
  method: 'to' | 'href',
  label: React.Element<any>
) {
  return (data: Object) => {
    return <LinkCell url={data[urlFieldName]} method={method} label={label} />;
  };
}
